module.exports = __webpack_public_path__ + "492a48bc63da02e6e45ba6e9aeae8ac4.woff";